import React from 'react';

import {SearchSection} from 'graphql-client/__generated/graphqlGlobalTypes';
import BaseSavedSearchModal from 'search/saved-searches/BaseSavedSearchModal';
import {SearchParams} from 'search/SearchConstants';
import {OptionValue} from 'ui-library/menus/MenuConstants';

export interface SavedSearchModalProps {
  searchSection: SearchSection;
  closeModal: () => void;
  onSelect: (value: OptionValue) => void;
  onSearch: (searchParams: SearchParams) => void;
  searchParams: SearchParams;
}

/** A modal for viewing and managing all Saved Searches. */
export default function SavedSearchModal(props: SavedSearchModalProps): JSX.Element {
  return <BaseSavedSearchModal showModalOptions={true} showOptionsMenu={true} {...props} />;
}
